import React, {useContext, useEffect, useState} from 'react';
import {FooterInfoVO, SettingsApi} from '../api';
import {Button, Col, Row} from 'react-bootstrap';
import {CookieContext} from '../contexts/CookieContext';
import Cookies from 'js-cookie';
import {MyCookieConsent} from './MyCookieConsent';
import {resetGTM, setGTM} from '../utils/GATools';

interface FooterProps {
    idPlanVerze: string;
}

export const Footer: React.FC<FooterProps> = ({idPlanVerze}) => {
    const {showFooter, gtmContainerId} = useContext(CookieContext);

    const cookiesAccepted = Cookies.get('CookieConsent');

    const [footerInfo, setFooterInfo] = useState<FooterInfoVO>();
    const [rerender, setRerender] = useState(false);

    const onAccept = () => {
        setGTM(gtmContainerId);
        setRerender(!rerender);
    };

    const onDecline = () => {
        setRerender(!rerender);
    };

    useEffect(() => {
        loadFooterInfo();
    }, [idPlanVerze]);

    const loadFooterInfo = () => {
        const fetchData = async () => {
            let footerInfo: FooterInfoVO;
            try {
                if (idPlanVerze) {
                    footerInfo = (await SettingsApi.getFooterInfo(parseInt(idPlanVerze))).data;
                    setFooterInfo(footerInfo);
                }
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    const resetCookies =
        cookiesAccepted !== undefined && showFooter ? (
            <Button
                variant={'link'}
                style={{padding: '0px 20px 0px 0px'}}
                onClick={() => {
                    Cookies.remove('CookieConsent');
                    resetGTM();
                    setRerender(!rerender);
                }}
            >
                Znovu nastavit cookies
            </Button>
        ) : null;
    const cookiesUrl = footerInfo?.cookiesUrl?.trim();
    const cookiesLink = cookiesUrl ? (
        <a style={{paddingRight: 20}} href={cookiesUrl}>
            Prohlášení o přístupnosti a cookies
        </a>
    ) : null;
    const updateLabel = footerInfo?.dataFrom ? 'Zobrazená data k: ' + footerInfo.dataFrom : null;

    return (
        <Row style={{margin: 0}}>
            <Col style={{paddingLeft: 20}}>
                <span className="touchable" onClick={() => window.open('https://www.marbes.cz')}>
                    PROXIO © 2022 Marbes Consulting s.r.o.
                </span>
            </Col>
            <Col style={{paddingRight: 20}} className="class-col">
                {resetCookies}
                {cookiesLink}
                {updateLabel}
            </Col>
            {showFooter && cookiesAccepted === undefined && (
                <MyCookieConsent onAccept={onAccept} onDecline={onDecline} visible={cookiesAccepted === undefined} />
            )}
        </Row>
    );
};
